interface HTMLContentProps {
  content: string;
  className?: string;
}

const HTMLContent = ({ content, className = "" }: HTMLContentProps) => {
  return (
    <div 
      className={`prose prose-sm max-w-none ${className}`}
      dangerouslySetInnerHTML={{ __html: content }}
      style={{
        // Custom styles for the rendered HTML content
        lineHeight: '1.6',
      }}
    />
  );
};

export default HTMLContent;